/* eslint-disable no-lone-blocks */
/* eslint-disable no-unreachable */
/* eslint-disable max-lines */
import React, { useEffect } from 'react'
import { useState } from 'react'
// import PreviewShareImage from './PreviewShareImage'
import TextBlocks from './TextBlocks'
import { Auth } from 'aws-amplify'
import GetContent from '../../Services/Queries/GetContent'

export default function RenderShareTemplates(props) {
  const { shareMediaThemeConfig } = props
  const [selectedTheme, setselectedTheme] = useState(shareMediaThemeConfig[0])
  const [contentData, setContentData] = useState({})
  const [render, setrender] = useState(false)
  // const [contentID, setcontentID] = useState({})

  // write usee effect and call get content service  with required inputs
  // now take that contnet data and set to  state
  // now pass this contentData to text block component

  useEffect(() => {
    const getContentData = async () => {
      const urlParams = window.location.href.split('?')
      // console.log(urlParams, "here is the urlParams")
      if (urlParams && urlParams[1]) {
        const contentID = 'cont#' + urlParams[1]
        const input = {
          appInfoFrontEnd: {
            UUID: Auth.user.username,
            appVersionNumber: 62,
          },
          contentID,
        }
        // console.log(input, "here is the content Id")

        const data = await GetContent(input)
        // console.log(data, "datatadata")
        if (data.contentLanguages && data.contentLanguages.length === 1) {
          if (data.contentType === 'Story' && data.storyType === 'ShortByte') {
            setselectedTheme(shareMediaThemeConfig[3])
          }

          console.log('inside useffectttttttttt')
          setrender(true)
          setContentData(data)
        }
      }
    }

    getContentData() // run it, run it
  }, [])

  const handleSelelectedTheme = item => {
    // here pass the item to the parent and make the item as selected
    // call the parent function ()
    setselectedTheme(item)
  }

  const rendersingleBoxStyle = item => (
    <div className='defaultTemplate'>
      ddd
      <div
        className={`shareCard  ${
          selectedTheme.themeName === item.themeName ? 'selectedTheme' : ''
        } d-flex justify-content-center`}
        style={{ backgroundColor: item.titleBackgroundColor }}
      >
        <img
          className='shareImageSample'
          src={item.sampleImage}
          alt='Girl in a jacket'
          width='500'
          height='600'
        />
        <div
          className='descriptionFont1'
          style={{
            color: item[`box${item.noOfTextBlocks}FontColor`],
            backgroundColor: `${item[`box${item.noOfTextBlocks}BackgroundColor`]}`,
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </div>
      </div>
    </div>
  )
  const renderTwoBoxStyle = item => (
    <div className='defaultTemplate'>
      <div
        className={`shareCard  ${
          selectedTheme.themeName === item.themeName ? 'selectedTheme' : ''
        }  d-flex justify-content-center align-items-center`}
        style={{ backgroundColor: item.titleBackgroundColor }}
      >
        <div
          className='titleFont'
          style={{ color: item.titleFontColor, backgroundColor: item.titleBackgroundColor }}
        >
          This.is the title for the share card
        </div>
        <img
          className='shareImageSample'
          src={item.sampleImage}
          alt='Girl in a jacket'
          width='500'
          height='600'
        />

        <div
          className='descriptionFont2'
          style={{
            color: item[`box${item.noOfTextBlocks}FontColor`],
            backgroundColor: `${item[`box${item.noOfTextBlocks}BackgroundColor`]}`,
          }}
        >
          This is sample description text block to display description for the share image card
        </div>
      </div>
    </div>
  )
  const renderThreeBoxStyle = item => (
    // console.log(item, "itemmmmmmm11")
    <div className='defaultTemplate'>
      <div
        className={`shareCard ${
          selectedTheme.themeName === item.themeName ? 'selectedTheme' : ''
        }  d-flex justify-content-center `}
        style={{ backgroundColor: item.titleBackgroundColor }}
      >
        <div
          className='titleFont'
          style={{ color: item.titleFontColor, backgroundColor: item.titleBackgroundColor }}
        >
          This.is the title for the share card
        </div>
        <img
          className='shareImageSample'
          src={item.sampleImage}
          alt='Girl in a jacket'
          width='500'
          height='600'
        />

        <div
          className='descriptionFont3'
          style={{ color: item.box2FontColor, backgroundColor: item.titleBackgroundColor }}
        >
          This is sample description text block 1
        </div>
        <div
          className='descriptionFont3'
          style={{
            color: item[`box${item.noOfTextBlocks}FontColor`],
            backgroundColor: `${item[`box${item.noOfTextBlocks}BackgroundColor`]}`,
          }}
        >
          This is sample description text block 2
        </div>
      </div>
    </div>
  )

  // eslint-disable-next-line no-unused-vars
  const rendersingleBoxStyle2 = item => (
    <div className='defaultTemplate'>
      <div
        className={`shareCard  ${
          selectedTheme.themeName === item.themeName ? 'selectedTheme' : ''
        } d-flex justify-content-center`}
        style={{ backgroundColor: item.titleBackgroundColor }}
      >
        <img
          className='shareImageSample'
          src={item.sampleImage}
          alt='Girl in a jacket'
          width='500'
          height='600'
        />
        <div
          className='descriptionFont1'
          style={{
            color: item[`box${item.noOfTextBlocks}FontColor`],
            backgroundColor: `${item[`box${item.noOfTextBlocks}BackgroundColor`]}`,
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </div>
      </div>
    </div>
  )
  const renderBlackAndYellowTheme = item => (
    <div className='defaultTemplate'>
      <div
        className={`shareCard  ${
          selectedTheme.themeName === item.themeName ? 'selectedTheme' : ''
        } d-flex justify-content-center`}
        style={{ backgroundColor: item.titleBackgroundColor }}
      >
        <img
          className='shareImageSample'
          src={item.sampleImage}
          alt='Girl in a jacket'
          width='500'
          height='600'
        />
        <div
          className='descriptionFont1'
          style={{
            color: 'yellow',
            backgroundColor: 'black',
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </div>
      </div>
    </div>
  )
  const renderTwoBoxStyleWithYellowBack = item => (
    <div className='defaultTemplate '>
      <div
        className={`shareCard  ${
          selectedTheme.themeName === item.themeName ? 'selectedTheme' : ''
        } d-flex justify-content-center`}
        style={{ backgroundColor: item.titleBackgroundColor }}
      >
        <img
          className='shareImageSample'
          src={item.sampleImage}
          alt='Girl in a jacket'
          width='500'
          height='600'
        />
        <div className='defaultblack'>
          <div className='descriptionFont001'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
            exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </div>
        </div>
        <div
          className='descriptionFont011'
          style={{
            color: item[`box${item.noOfTextBlocks}FontColor`],
            backgroundColor: `${item[`box${item.noOfTextBlocks}BackgroundColor`]}`,
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </div>
      </div>
    </div>
  )

  const topOneDisc = item => (
    <div className='defaultTemplate'>
      <div
        className={`shareCard  ${
          selectedTheme.themeName === item.themeName ? 'selectedTheme' : ''
        } d-flex justify-content-center`}
        style={{ backgroundColor: item.titleBackgroundColor }}
      >
        <div
          className='descriptionFont1'
          style={{
            color: item[`box${item.noOfTextBlocks}FontColor`],
            backgroundColor: `${item[`box${item.noOfTextBlocks}BackgroundColor`]}`,
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua.
        </div>
        <img
          className='shareImageSample'
          src={item.sampleImage}
          alt='Girl in a jacket'
          width='500'
          height='600'
        />
      </div>
    </div>
  )

  const topAndBottumDisc = item => (
    <div className='defaultTemplate '>
      <div
        className={`shareCard  ${
          selectedTheme.themeName === item.themeName ? 'selectedTheme' : ''
        } d-flex justify-content-center`}
        style={{ backgroundColor: item.titleBackgroundColor }}
      >
        <div
          className='topand'
          style={{ height: '15%', color: 'yellow', backgroundColor: 'black', overflow: 'hidden' }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        </div>
        <div
          className='topand'
          style={{ height: '15%', color: 'white', backgroundColor: 'black', overflow: 'hidden' }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        </div>
        <img
          className='shareImageSample'
          src={item.sampleImage}
          alt='Girl in a jacket'
          width='500'
          height='600'
        />

        <div
          className='descriptionFont011'
          style={{
            height: '15%',
            color: 'yellow',
            backgroundColor: `${item[`box${item.noOfTextBlocks}BackgroundColor`]}`,
          }}
        >
          Lorem ipsum dolor sit
        </div>
        <div
          className='descriptionFont061'
          style={{ height: '15%', color: 'white', backgroundColor: 'black' }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        </div>
      </div>
    </div>
  )

  const renderBoxStyle = item => {
    switch (item.themeName) {
      case 'Yellow & Red':
        // return rendersingleBoxStyle(item)
        return renderTwoBoxStyle(item)
        break
        // case 'Red & Yellow':
        break
      case 'Red & Yellow':
        return renderThreeBoxStyle(item)
        break

      case 'Black & Yellow':
        return renderBlackAndYellowTheme(item)
        break
      case 'discOneYellowBack':
        return renderTwoBoxStyleWithYellowBack(item)
        break
      case 'toponedisc':
        return topOneDisc(item)
        break
      case 'topAndBottumDisc':
        return topAndBottumDisc(item)
      default:
        return rendersingleBoxStyle(item)
        break
    }
  }

  // const displayToast = (type, message) => {
  // 	if (type == 'success') {
  // 		toast.success(message, this.toastStyle)
  // 	} else {
  // 		toast.error(message, this.toastStyle)
  // 	}
  // }

  const renderThemes = () => {
    {
      /* example : {
							id: 1,
						themeName: "Yellow & red",
						// backgroundColor: "",
						// fontColor: "",
						// fontSize: "",
						noOfTextBlocks: "",
						titleFontSize: "",
						titleFontColor: "",
						titleBackgroundColor: "",
						box1FontColor: "",
						box1
						box1BackgroundColor: "",
						box2FontColor: "",
						box2BackgroundColor: "",
						box3FontColor: "",
						box3BackgroundColor: "",
						},
						When ever user selects the particular theme
						no of blocks,title ,box (sizes and colors should be taken from the object)
						*/
    }

    return (
      <>
        <div>
          <div className='card-group'>
            <section className='main-section'>
              {shareMediaThemeConfig.map((item, index) => (
                <div onClick={() => handleSelelectedTheme(item)} key={index}>
                  <label style={{ textAlign: 'center', width: '100%' }}>Template {item.sno}</label>
                  {renderBoxStyle(item)}
                </div>
              ))}
            </section>
          </div>
        </div>
      </>
    )
  }

  return (
    // Here map the themeConfig data and display them as boxes
    <div>
      <text>Share Content</text>

      {renderThemes()}
      {/* display the blocks and colors based on the selected themes */}
      {/* display the number of text input for the user to enter the title and descirption for share */}
      {render && <TextBlocks contentData={contentData} selectedTheme={selectedTheme} />}
      {/* here render the preview for the selected theme and the entered values */}
    </div>
  )
}
